export const getSessions = (state) => {
    return state.sessions;
}

export const getSpeakers = (state) => {
    return state.speakers;
}

export const getSpeakerById = (state) => (speakerId) => {
    return state.speakers.find(
        (s) => s._id === speakerId
    );
};

export const getScheduleGrid = (state) => {
    return state.scheduleGrid
}


// WEBPACK FOOTER //
// ./src/store/getters.js